import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FavContext = createContext(null);

export const FavoritesProvider = ({ children }) => {
  const { user, login } = useAuth();
  const [slugs, setSlugs] = useState([]);

  useEffect(() => {
    if (!user) return setSlugs([]);
    api.get("/favorites").then(({ data }) => setSlugs(data.map((p) => p.slug))).catch(() => {});
  }, [user]);

  const toggle = useCallback(
    async (product) => {
      if (!user) {
        toast("Sign in to save favorites", { action: { label: "Sign in", onClick: login } });
        return;
      }
      const on = slugs.includes(product.slug);
      setSlugs((s) => (on ? s.filter((x) => x !== product.slug) : [...s, product.slug]));
      try {
        await (on ? api.delete(`/favorites/${product.slug}`) : api.post(`/favorites/${product.slug}`));
      } catch {
        setSlugs((s) => (on ? [...s, product.slug] : s.filter((x) => x !== product.slug)));
        toast.error("Couldn't update favorites. Please try again.");
      }
    },
    [user, slugs, login]
  );

  return <FavContext.Provider value={{ slugs, toggle }}>{children}</FavContext.Provider>;
};

export const useFavorites = () => useContext(FavContext);
